import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response, RequestOptions, Headers} from '@angular/http';
import { environment } from '../../../environments/environment';
// import * as $ from 'jquery';
declare var $ : any;
import swal from 'sweetalert2';

@Component({
	selector: 'app-truck-report',
	templateUrl: './truck-report.component.html',
	styleUrls: ['./truck-report.component.css']
})

export class TruckReportComponent implements OnInit {

	url = environment.url
	truckReportForm : FormGroup;
	query : any = null;
	report_data : any = null;
	lr_forms_trucks : any = null;
	lr_forms_account : any = null;
	lr_forms_sto : any = null;

	constructor( private http : Http) { }

	ngOnInit() {
		
		this.truckReportForm = new FormGroup({
			"date_range" : new FormControl(null, Validators.required),
			"invoice_by" : new FormControl(null, Validators.required)
		})
		
	};

	process(){
		console.log(this.truckReportForm.value);
		this.query = this.truckReportForm.value;
		if (this.query.invoice_by == "By S.T.O"){
			this.query.invoice_by = "sto_number"
		}
		else if(this.query.invoice_by == "By On_Account"){
			this.query.invoice_by = "on_account"
		}
		else{
			this.query.invoice_by = "truck_number"
		}
		console.log(this.query);
		const headers = new Headers();
		const options = new RequestOptions({ headers: headers });
		const path = this.url + '/reports/lr/' + this.query.invoice_by;
		this.http.post(path, this.query, options)
		.subscribe(res=>{
			this.report_data = res.json();
			console.log(this.report_data)
			if (this.query.invoice_by == "sto_number"){
				this.lr_forms_sto = this.report_data.data
				this.lr_forms_trucks = null
				this.lr_forms_account = null
			}
			else if(this.query.invoice_by == "on_account"){
				this.lr_forms_account = this.report_data.data
				this.lr_forms_trucks = null
				this.lr_forms_sto = null
			}
			else{
				this.lr_forms_trucks = this.report_data.data
				this.lr_forms_account = null
				this.lr_forms_sto = null
			}


		})
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/reports/truck-report/truck-report.component.ts